import { getRecentErrors } from './recentErrors';

export interface SupportContext {
  route: string;
  entityId: string | null;
  appMode: string;
  userAgent: string;
  viewport: string;
  language: string;
  timeZone: string;
  online: boolean;
  recentErrors: string[];
}

/** Pull a trailing id-looking segment (uuid/guid/numeric/slug) from the path. */
function extractEntityId(pathname: string): string | null {
  const segments = pathname.split('/').filter(Boolean);
  const last = segments[segments.length - 1];
  if (!last) return null;
  const looksLikeId = /^[0-9]+$/.test(last) || /[0-9a-f-]{6,}/i.test(last) || /^[a-z0-9]+-[a-z0-9]+$/i.test(last);
  return looksLikeId ? last : null;
}

/** Assemble the diagnostic context attached to a support report. */
export function collectSupportContext(): SupportContext {
  return {
    route: window.location.pathname + window.location.search,
    entityId: extractEntityId(window.location.pathname),
    appMode: import.meta.env.MODE,
    userAgent: navigator.userAgent,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    language: navigator.language,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    online: navigator.onLine,
    recentErrors: getRecentErrors(),
  };
}
